<template>
    <div class="sara_body_bg">
        <div class="nuxt-page-view" :class="{ mobile: isMobile }">
            <div class="w-full py-8 px-4">
                <sidebar-mobile-menu />
                <NuxtPage />
            </div>
        </div>
        <!-- sara sidebar -->
        <soc-sara-sidebar />
    </div>
</template>

<script setup>
import SocSaraSidebar from '~/components/layout/SocSidebar/SocSaraSidebar.vue'
import SidebarMobileMenu from '~/components/layout/SocSidebar/SidebarMobileMenu.vue';

const isMobile = ref(false);

// Check if we're on mobile/tablet
onMounted(() => {
    const checkMobile = () => {
        isMobile.value = window.innerWidth < 1025;
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    onUnmounted(() => {
        window.removeEventListener('resize', checkMobile);
    });
});
</script>

<style lang="scss" scoped>
.nuxt-page-view {
    @apply mr-80;
    height:100vh;
    transition: margin-right 0.3s ease-in-out;

    &.mobile {
        margin-right: 0;
    }
    @media screen and (max-width: 1024px) {
        margin-right: 0;
    }
}
.sara_body_bg {
    background: url('/assets/images/soc/sara_bg.png');
    background-color: #18181B;
    height: 100vh;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position:right;
    overflow:auto;
}

</style>
